export default __webpack_public_path__ + "static/media/saturn.89d03974.jpg";